import classnames from 'classnames'
import { SOURCES_MAX_CONTENTS } from 'Constants/index'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilState, useRecoilValue } from 'recoil'

import styled from '@emotion/styled'
import {
  Badge,
  BADGE_KIND_SECONDARY,
  BADGE_TYPE_WARNING,
  Flex,
  FlexItem,
  HelpIcon,
  Panel,
  SKELETON_LOADER_VARIANT_ONWHITE,
  SkeletonLoader,
  Text,
  TEXT_VARIANT_LIGHT,
  Title,
  TITLE_VARIANT_M,
  TITLE_VARIANT_XL,
  TooltipUtils
} from 'mailup-web-components'
import './icons.scss'

import { recallContentsCallback } from 'Pages/SourceEdit/recoil/callbacks/callbacks'
import {
  contentsState,
  MAX_CALLS,
  sourceState
} from 'Pages/SourceEdit/recoil/state/source'

const PanelContents = () => {
  const intl = useIntl()

  const [
    { loading, loaded, error, totalItems, showBadge, callNum },
    setContentsState
  ] = useRecoilState(contentsState)
  const { idSource } = useRecoilValue(sourceState)
  const recallContents = useRecoilCallback(recallContentsCallback, [])

  useEffect(() => {
    if (callNum > -1 && callNum <= MAX_CALLS) {
      setTimeout(() => recallContents(callNum), 1500)
    }
  }, [callNum])

  useEffect(() => {
    setContentsState((prev) => ({
      ...prev,
      error: totalItems === 0
    }))
  }, [totalItems])

  useEffect(() => {
    TooltipUtils.rebuild()
  }, [])

  useEffect(() => {
    TooltipUtils.rebuild()
  }, [idSource])

  return (
    <StyledPanel>
      <Flex flexDirection='row' columnGap='32px'>
        <FlexItem>
          <span
            className={classnames('icon__contents', {
              icon__contents__loaded:
                !error && totalItems !== 0 && loaded && !loading,
              icon__contents__error:
                (error || totalItems === 0) && loaded && !loading,
              icon__contents__loading: loading,
              icon__contents__disabled: idSource === 0
            })}
          />
        </FlexItem>
        <FlexItem>
          <Flex
            flexDirection='column'
            alignItems='flex-start'
            justifyContent='center'
          >
            <FlexItem>
              <Flex flexDirection='row' columnGap='8px' alignItems='baseline'>
                {loading ? (
                  <SkeletonLoader
                    variant={SKELETON_LOADER_VARIANT_ONWHITE}
                    height='28px'
                    width='16px'
                  />
                ) : (
                  <StyledTitle variant={TITLE_VARIANT_XL}>
                    {idSource > 0 ? totalItems : '-'}
                  </StyledTitle>
                )}
                <Title variant={TITLE_VARIANT_M}>
                  {idSource > 0 && totalItems === 1
                    ? intl.formatMessage({
                        id: 'Load.ContentsSouces.ItemFromSource'
                      })
                    : intl.formatMessage({
                        id: 'Load.ContentsSouces.ItemsFromSource'
                      })}
                </Title>
                {idSource > 0 && (
                  <StyledHelpIcon
                    text={intl.formatMessage({
                      id: 'Load.ContentsSouces.ItemsFromSourceTooltip'
                    })}
                  />
                )}
                {showBadge && (
                  <Badge
                    kind={BADGE_KIND_SECONDARY}
                    type={BADGE_TYPE_WARNING}
                    text={intl.formatMessage({
                      id: 'Load.Common.UploadInProgress'
                    })}
                  />
                )}
              </Flex>
            </FlexItem>
            <FlexItem>
              <Text variant={TEXT_VARIANT_LIGHT}>
                {intl.formatMessage(
                  { id: 'Load.ContentsSouces.ContentMax' },
                  { N: SOURCES_MAX_CONTENTS }
                )}
              </Text>
            </FlexItem>
          </Flex>
        </FlexItem>
      </Flex>
    </StyledPanel>
  )
}

export default PanelContents

const StyledTitle = styled(Title)`
  font-weight: 500 !important;
`

const StyledHelpIcon = styled(HelpIcon)`
  align-self: baseline;
`

const StyledPanel = styled(Panel)`
  position: relative;

  .e-badge {
    position: absolute;
    top: 8px;
    right: 8px;
  }
`
